import { render, staticRenderFns } from "./release-authorization-listing.component.vue?vue&type=template&id=d3f7e5be&"
import script from "./release-authorization-listing.component.vue?vue&type=script&lang=ts&"
export * from "./release-authorization-listing.component.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports